import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DepositFilters } from '@repo/position-types'

const initialState = null as DepositFilters | null

export const { actions: positionDepositsFiltersActions, reducer: positionDepositsFiltersReducers } =
  createSlice({
    name: '@position/master/filters/deposits',
    initialState,
    reducers: {
      clearFilter: () => {
        return null
      },
      setFilter: (_, action: PayloadAction<DepositFilters>) => {
        return action.payload
      },
    },
  })
